<template>
  <div class="serviceHealth">
    <div v-if="dataSource.statistic && dataSource.statistic.length">
      <a-row
        v-for="item in dataSource.statistic"
        :key="item.id"
        :gutter="16"
        style="margin-bottom: 16px;"
      >
        <a-col :span="4">
          <div class="leftContainer">
            <div class="title">{{ item.name }}</div>
            <div class="value" :style="{color: getColor(item.score)}">{{ item.score }}</div>
            <div class="progress">
              <a-progress
                size="small"
                status="active"
                :percent="item.score"
                :show-info="false"
                :stroke-color="{
                  '0%': `${getColor(item.score)}99`,
                  '100%': getColor(item.score)
                }"
              />
            </div>
          </div>
        </a-col>
        <a-col :span="20">
          <div class="mainContainer">
            <a-tabs tabPosition="left">
              <a-tab-pane
                v-for="tabData in item.children"
                :key="tabData.id"
                :tab="tabData.name"
              >
                <resource-table
                  :detail="tabData"
                ></resource-table>
              </a-tab-pane>
            </a-tabs>
          </div>
        </a-col>
      </a-row>
    </div>

    <empty-component
      v-else
      :imgUrl="require('@/assets/images/info_empty.png')"
      :body-style="{
        height: '216px',
        marginTop: '0px'
      }"
      :description-style="{
        marginTop: '-32px',
        marginRight: '8px'
      }"
      description="暂无数据"
      style="margin-top: 12vh"
    ></empty-component>
  </div>
</template>

<script>
import { getServiceHealth } from '@/api/service.js'
import ResourceTable from './module/ResourceTable.vue'
import EmptyComponent from '@/components/EmptyComponent.vue'

export default {
  name: 'ServiceHealth',
  components: {
    ResourceTable,
    EmptyComponent
  },
  data () {
    return {
      serviceId: this.$route.params.id,
      dataSource: {}
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      getServiceHealth(this.serviceId).then(res => {
        this.dataSource = res.data
      })
    },
    getColor (score) {
      let c = '#f5222d'
      if (score >= 80) c = '#43B94D'
      else if (score >= 60) c = '#fa8c16'
      return c
    }
  }
}
</script>

<style lang="less" scoped>
.serviceHealth {
  .leftContainer {
    background: #fff;
    border-radius: 6px;
    min-height: 200px;
    padding: 24px;
    text-align: center;
    flex-direction: column;
    display: flex;
    justify-content: space-evenly;
    .value {
      font-size: 30px;
      &::after {
        content: '分';
        font-size: 12px;
        margin-left: 2px;
        color: #6e6e6e;
      }
    }
  }
  .mainContainer {
    background: #fff;
    border-radius: 6px;
    padding: 8px 12px 8px;
    margin: 0;
    min-height: 200px;

    .ant-tabs {
      margin-top: 16px;
      .ant-tabs-content {
        min-height: 382px;
      }
    }
  }
}
</style>
